exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fk-input-container[data-v-22f539f4]{display:inline-block}.fk-input-container input[data-v-22f539f4]{border:none;margin-left:10px;text-align:center}.fk-input-container input[data-v-22f539f4]:first-child{margin-left:0}.fk-input-container input[data-v-22f539f4]:focus{outline:none}", ""]);

// exports
